angular
	.module 'App.Repository'
	.factory 'InventoryCountRepository',
	[
		'BaseRepository',
		(BaseRepository) ->
			class InventoryCountRepository extends BaseRepository
				@resource = '/inventory_counts'
				@isRestricted = true

				getNotCountedProducts: (inventoryCountId, productId, offset, limit) ->
					query = @getQuery()
					query
						.addParameter('offset', offset)
						.addParameter('limit', limit)

					if productId?
						query.addParameter 'product_id', productId

					return @find("#{inventoryCountId}/not_counted_products", query).then (response) => response.data

				getStats: (inventoryCountId) ->
					return @find("#{inventoryCountId}/stats").then (response) => response.data

				getUndoState: (inventoryCountId) ->
					return @find("#{inventoryCountId}/undo_state").then (response) => response.data

				undo: (inventoryCountId) ->
					return @post("#{inventoryCountId}/undo").then (response) => response.data

			return new InventoryCountRepository
	]
